<template>
  <v-app class="futuristic-app">

    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" />
          </div>

          <div class="brand-copy d-block d-sm-none d-lg-block">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="Cari kecamatan..."
          solo
          flat
          rounded
          clearable
          hide-details
          background-color="#f1f6f5"
          class="header-search mr-3 d-none d-sm-flex"
        />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74"> mdi-map-outline </v-icon>
          </div>

          <div>
            <div class="header-info-title">Wilayah Kecamatan</div>
            <div class="header-info-subtitle">{{ filteredKecamatan.length }} kecamatan</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container class="py-12 content-layer" style="max-width: 1200px">
        <div class="d-flex align-center mb-10 px-4">
          <div class="line-decorator-gold mr-4"></div>
          <h2 class="black--text text-overline letter-spacing-4">
            IDENTIFIKASI_SEKTOR_WILAYAH
          </h2>
        </div>

        <div class="scrollable-content-area">
          <v-row v-if="filteredKecamatan.length > 0" class="modern-grid">
            <v-col
              v-for="item in filteredKecamatan"
              :key="item.id"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card class="modern-kecamatan-card" ripple @click="goToPotensi(item)">
                <div class="card-gradient"></div>

                <div class="floating-icon">
                  <v-icon size="42" color="white"> mdi-map-marker-radius </v-icon>
                </div>

                <div class="card-content">
                  <div class="mini-label">KECAMATAN</div>

                  <h3 class="kecamatan-title">
                    {{ item.nama_kecamatan }}
                  </h3>

                  <div class="status-chip">
                    <span class="dot"></span>
                    DATA TERSEDIA
                  </div>

                  <div class="bottom-action">
                    <span>Lihat Potensi</span>

                    <div class="arrow-circle">
                      <v-icon size="18" color="white"> mdi-arrow-right </v-icon>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else class="text-center mt-15">
            <v-col>
              <v-icon size="100" color="rgba(207, 162, 45, 0.1)"
                >mdi-satellite-variant</v-icon
              >
              <div class="black--text opacity-5 mt-4 letter-spacing-4 font-weight-bold">
                SECTOR_NOT_DETECTED
              </div>
              <v-btn text color="#018c74" @click="search = ''" class="mt-2"
                >RE-SCAN_DIRECTORY</v-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import { getKecamatan } from "@/api/androidInitApi";

export default {
  data: () => ({
    search: "",
    listKecamatan: [],
    particles: [],
    ctx: null,
    animationId: null,
  }),
  computed: {
    filteredKecamatan() {
      return this.listKecamatan.filter((item) => {
        return item.nama_kecamatan.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  mounted() {
    this.initParticles();
    window.addEventListener("resize", this.resizeCanvas);
    this.fetchData();
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animationId);
    window.removeEventListener("resize", this.resizeCanvas);
  },
  methods: {
    async fetchData() {
      try {
        this.listKecamatan = (await getKecamatan()) || [];
      } catch (e) {
        console.error("System Failure:", e);
      }
    },
    initParticles() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      this.ctx = canvas.getContext("2d");
      this.resizeCanvas();
      this.particles = Array.from({ length: 45 }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.3,
        vy: (Math.random() - 0.5) * 0.3,
        radius: Math.random() * 2 + 1,
      }));
      this.animate();
    },
    resizeCanvas() {
      const canvas = this.$refs.particleCanvas;
      if (canvas) {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      }
    },
    animate() {
      if (!this.ctx) return;
      this.ctx.clearRect(
        0,
        0,
        this.$refs.particleCanvas.width,
        this.$refs.particleCanvas.height
      );
      this.particles.forEach((p, i) => {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0 || p.x > this.$refs.particleCanvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > this.$refs.particleCanvas.height) p.vy *= -1;
        this.ctx.beginPath();
        this.ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        this.ctx.fillStyle = "rgba(1, 140, 116, 0.4)";
        this.ctx.fill();
        for (let j = i + 1; j < this.particles.length; j++) {
          const p2 = this.particles[j];
          const dist = Math.hypot(p.x - p2.x, p.y - p2.y);
          if (dist < 150) {
            this.ctx.beginPath();
            this.ctx.moveTo(p.x, p.y);
            this.ctx.lineTo(p2.x, p2.y);
            this.ctx.strokeStyle = `rgba(1, 140, 116, ${0.3 - dist / 400})`;
            this.ctx.lineWidth = 0.5;
            this.ctx.stroke();
          }
        }
      });
      this.animationId = requestAnimationFrame(this.animate);
    },
    goToPotensi(kec) {
      const targetId = kec.id_kecamatan || kec.id;

      console.log("Mengirim ID Kecamatan:", targetId);

      this.$router.push({
        name: "list_desa",
        query: {
          id_kec: targetId,
          nama_kec: kec.nama_kecamatan,
        },
      });
    },
  },
};
</script>

<style scoped>
.modern-grid {
  row-gap: 24px;
}

.modern-kecamatan-card {
  position: relative;
  overflow: hidden;
  border-radius: 28px !important;
  min-height: 240px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.82) !important;
  backdrop-filter: blur(18px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  transition: all 0.35s ease;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.modern-kecamatan-card:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 20px 50px rgba(1, 140, 116, 0.22), 0 0 0 1px rgba(1, 140, 116, 0.15);
}

.card-gradient {
  position: absolute;
  top: -80px;
  right: -80px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: linear-gradient(135deg, #018c74, #00cec9);
  opacity: 0.15;
}

.floating-icon {
  position: absolute;
  top: 20px;
  right: 20px;

  width: 72px;
  height: 72px;
  border-radius: 22px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(90deg, #016b62 0%, #018c74 45%, #8bcdc6 100%);

  box-shadow: 0 10px 25px rgba(1, 140, 116, 0.35);
}

.card-content {
  position: relative;
  z-index: 2;
  padding: 26px;
  height: 100%;

  display: flex;
  flex-direction: column;
}

.mini-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #018c74;
  margin-bottom: 14px;
}

.kecamatan-title {
  font-size: 1.45rem;
  font-weight: 800;
  line-height: 1.3;
  color: #1f2937;
  margin-bottom: 18px;
  max-width: 75%;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  width: fit-content;

  padding: 8px 14px;
  border-radius: 999px;

  background: rgba(1, 140, 116, 0.08);

  color: #018c74;
  font-size: 12px;
  font-weight: 700;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #00c853;

  box-shadow: 0 0 12px #00c853;
}

.bottom-action {
  margin-top: auto;

  display: flex;
  align-items: center;
  justify-content: space-between;

  font-weight: 700;
  color: #111827;
}

.arrow-circle {
  width: 42px;
  height: 42px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(90deg, #016b62 0%, #018c74 45%, #8bcdc6 100%);

  transition: all 0.3s ease;
}

.modern-kecamatan-card:hover .arrow-circle {
  transform: translateX(5px);
}

@media (max-width: 768px) {
  .modern-kecamatan-card {
    min-height: 210px;
  }

  .kecamatan-title {
    font-size: 1.2rem;
    max-width: 100%;
  }

  .floating-icon {
    width: 60px;
    height: 60px;
  }}
:root {
  --bg-teal: #018c74;
  --bg-teal-dark: #016b62;
  --bg-teal-light: #8bcdc6;
  --bone-white: #f5f5f5;
  --bone-light: #fafafa;
  --text-primary: #2e2e2e;
  --accent-gold: #ffa726;
  --accent-teal: #018c74;
}

.scrollable-content-area {
  max-height: calc(100vh - 300px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
}

.scrollable-content-area::-webkit-scrollbar {
  width: 5px;
}
.scrollable-content-area::-webkit-scrollbar-track {
  background: rgba(45, 138, 122, 0.12);
}
.scrollable-content-area::-webkit-scrollbar-thumb {
  background: rgba(38, 166, 154, 0.6);
  border-radius: 10px;
}
.scrollable-content-area::-webkit-scrollbar-thumb:hover {
  background: var(--accent-gold);
}



.kecamatan-tile-v2 {
  background: #f5f5f5 !important;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(45, 138, 122, 0.25) !important;
  border-radius: 16px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  position: relative;
  cursor: pointer;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.kecamatan-tile-v2:hover {
  transform: translateY(-8px);
  border-color: var(--accent-teal) !important;
  background: rgba(45, 138, 122, 0.08) !important;
  box-shadow: 0 20px 50px rgba(38, 166, 154, 0.25);
}

.accent-top-bar {
  height: 4px;
  width: 100%;
  background: linear-gradient(90deg, var(--accent-teal), var(--accent-gold));
  position: absolute;
  top: 0;
  left: 0;
}

.action-btn-cyber {
  border: 1px solid rgba(45, 138, 122, 0.5) !important;
  background: rgba(45, 138, 122, 0.08) !important;
  border-radius: 8px !important;
  letter-spacing: 1.5px;
  font-weight: bold;
  color: var(--text-primary) !important;
  transition: all 0.3s ease;
}

.kecamatan-tile-v2:hover .action-btn-cyber {
  background: var(--accent-teal) !important;
  color: var(--bone-white) !important;
  box-shadow: 0 4px 16px rgba(38, 166, 154, 0.4);
}

.corner-tl {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 10px;
  height: 10px;
  border-left: 2px solid var(--accent-teal);
  border-top: 2px solid var(--accent-teal);
  opacity: 0.6;
}
.corner-br {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 10px;
  height: 10px;
  border-right: 2px solid var(--accent-gold);
  border-bottom: 2px solid var(--accent-gold);
  opacity: 0.6;
}

.icon-orb-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.orb-glow {
  position: absolute;
  width: 60px;
  height: 60px;
  background: radial-gradient(circle, rgba(255, 167, 38, 0.2) 0%, transparent 70%);
  border-radius: 50%;
  animation: pulse 3s infinite;
}
@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
}

.gold--text {
  color: var(--accent-gold) !important;
}
.letter-spacing-2 {
  letter-spacing: 2px;
}
.letter-spacing-4 {
  letter-spacing: 4px;
}
.opacity-8 {
  opacity: 0.8;
}
.title-accent {
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  color: var(--text-primary);
}
.line-decorator-gold {
  width: 45px;
  height: 4px;
  background: var(--accent-gold);
  border-radius: 2px;
}

@media (max-width: 768px) {
  .kecamatan-tile-v2:hover {
    transform: translateY(-4px);
  }
  .accent-top-bar {
    height: 3px;
  }}


.futuristic-app {
  background: #f6f9f9 !important;
}

.main-area {
  background: radial-gradient(circle at 90% 5%, rgba(1, 140, 116, 0.035), transparent 25%),
    #f6f9f9;
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;

  backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;

  z-index: 20 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;

  margin: 0 auto;

  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;

  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);

  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;

  border-radius: 10px;

  background: #f1faf8;

  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;

  font-size: 10px;
  color: #929da1;
  margin-top: 1px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-search {
  max-width: 300px;
}

.header-search-wrap {
  min-width: 0;
}

.header-search ::v-deep .v-input__slot,
.cyber-search-dropdown ::v-deep .v-input__slot {
  min-height: 42px !important;

  background: #f1f6f5 !important;

  border: 1px solid rgba(1, 140, 116, 0.12) !important;

  box-shadow: none !important;

  transition: all 0.25s ease;
}

.header-search ::v-deep .v-input__slot:focus-within,
.cyber-search-dropdown ::v-deep .v-input__slot:focus-within {
  background: #ffffff !important;

  border-color: #018c74 !important;
}

.header-search ::v-deep .v-icon,
.cyber-search-dropdown ::v-deep .v-icon {
  color: #018c74;
}

@media (max-width: 600px) {
  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;
    height: 35px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }
}
</style>
